import { useRef } from "react";
import Button from "./Button";

export default function FilePickerButton(props) {
    const fileRef = useRef(null);

    return (
        <>
            <Button className={props.className} id={`${props.id}-button`}
                  disabled={props.disabled}
                  loading={props.loading}
                  onClick={() => fileRef.current.click()}
                  text={props.text} />

            <input style={{display: 'none'}}
                id={`${props.id}-file-input`}
                type="file" 
                accept={props.accepts} 
                ref={fileRef} 
                onChange={props.onChange} 
                onClick={(e) => e.target.value = null} />
        </>
    )
}